import React from 'react';
import { motion } from 'framer-motion';
import { Users, Activity, TrendingUp } from 'lucide-react';

const AdminStatsCards = ({ stats }) => {
  if (!stats) return null;

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
      <motion.div
        className="bg-zinc-900/50 border border-white/5 backdrop-blur-md rounded-2xl p-6"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        data-testid="total-users-card"
      >
        <Users className="w-6 h-6 text-neon-lime mb-3" />
        <p className="text-zinc-400 text-sm uppercase tracking-wider mb-1">
          Total de Usuários
        </p>
        <p className="font-primary font-black text-4xl text-white">
          {stats.total_users}
        </p>
      </motion.div>

      <motion.div
        className="bg-zinc-900/50 border border-white/5 backdrop-blur-md rounded-2xl p-6"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1 }}
        data-testid="active-users-card"
      >
        <Activity className="w-6 h-6 text-utility-success mb-3" />
        <p className="text-zinc-400 text-sm uppercase tracking-wider mb-1">
          Usuários Ativos
        </p>
        <p className="font-primary font-black text-4xl text-utility-success">
          {stats.active_users}
        </p>
      </motion.div>

      <motion.div
        className="bg-zinc-900/50 border border-white/5 backdrop-blur-md rounded-2xl p-6"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
        data-testid="total-workouts-card"
      >
        <TrendingUp className="w-6 h-6 text-neon-purple mb-3" />
        <p className="text-zinc-400 text-sm uppercase tracking-wider mb-1">
          Total de Treinos
        </p>
        <p className="font-primary font-black text-4xl text-white">
          {stats.total_workouts}
        </p>
      </motion.div>

      <motion.div
        className="bg-zinc-900/50 border border-white/5 backdrop-blur-md rounded-2xl p-6"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3 }}
        data-testid="total-posts-card"
      >
        <Activity className="w-6 h-6 text-neon-lime mb-3" />
        <p className="text-zinc-400 text-sm uppercase tracking-wider mb-1">
          Posts Comunitários
        </p>
        <p className="font-primary font-black text-4xl text-white">
          {stats.total_posts}
        </p>
      </motion.div>
    </div>
  );
};

export default AdminStatsCards;
